



























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, PropSync } from 'vue-property-decorator';
import virtualList from 'vue-virtual-scroll-list';
import DirectoryItem from './DirectoryItem.vue';
import { contacts, user } from '@/modules/shared/shared/store/namespaces';
import { UserGetters } from '@/modules/users/store/user.getters';
import { User } from '@/modules/users/domain/user';
import { ContactsActions } from '@/modules/contacts/shared/store/contacts.actions';
import { ContactsGetters } from '@/modules/contacts/shared/store/contacts.getters';
import { CustomerContact } from '@/modules/contacts/shared/domain/customer-contact';
import { DirectoryItem as Item } from '@/modules/contacts/shared/domain/directory-item';
@Component({
    components: {
        virtualList,
        DirectoryItem,
    },
})
export default class Directory extends Vue {
    @Prop({ default: false })
    readonly adminUser!: boolean;

    @Prop()
    contactToDisplay!: number;

    @Prop()
    customer!: any;

    @Prop()
    maxHeight!: number;

    @Prop()
    modalCheck!: boolean;

    @PropSync('selectedValuesProp', {
        default: function() {
            return Array();
        },
    })
    selectedValues!: number[];

    @Prop({ required: false, default: 50, type: Number })
    size!: number;

    loadingDirectoryFailed: RequestResponse = false;

    mounted() {
        this.getContacts();
    }

    contactSearch: string = '';
    loadingContacts: boolean = true;

    @Emit('contactClicked')
    emitContact(contact: Partial<CustomerContact>) {
        return contact;
    }

    reset() {
        this.getContacts();
    }

    get customerId() {
        const customerId: number = this.currentUser.contact.customer.id;

        if (this.customer && this.customer !== -1) {
            return this.customer;
        } else {
            return customerId;
        }
    }

    get directory() {
        let directory: {
            letter: string;
            contacts: any[];
        }[] = [];

        let directoryListAux: { contacts: any[] } = { contacts: [] };

        if (!this.loadingContacts && this.directoryList.length) {
            let letters: string[] = [];
            let contactNames: string[] = [];

            this.directoryList.sort(function(a: any[number], b: any[number]) {
                let fullNameA = a.name
                    .toUpperCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '');
                let fullNameB = b.name
                    .toUpperCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '');

                if (fullNameA < fullNameB) {
                    return -1;
                }

                if (fullNameA > fullNameB) {
                    return 1;
                }

                return 0;
            });

            this.directoryList.forEach((v: any) => {
                letters.push(
                    v.name
                        .split(', ')[0][0]
                        .toUpperCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, ''),
                );
            });

            letters = [...new Set(letters)];

            letters.forEach((l: any) => {
                let directoryItem: {
                    letter: string;
                    contacts: any[];
                } = {
                    letter: '',
                    contacts: [],
                };

                directoryItem.letter = l;

                this.directoryList.forEach(c => {
                    if (
                        c.name
                            .split(', ')[0][0]
                            .toUpperCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '') ===
                        l
                            .toUpperCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                    ) {
                        directoryItem.contacts.push(c);
                    }
                });
                directory.push(directoryItem);
            });

            let i = -1;

            directory.forEach(item => {
                let indexLetterAsAContact: Item = {
                    id: -1,
                    name: '',
                    show: true,
                    adminUser: false,
                };

                indexLetterAsAContact.id = i;
                indexLetterAsAContact.name = item.letter;
                i--;

                let contactsInSearch = false;

                item.contacts.forEach(contact => {
                    if (this.contactSearch != '') {
                        if (!this.filterByContact(contact.name)) {
                            contact.show = false;
                        } else {
                            contact.show = true;
                            contactsInSearch = true;
                        }
                    } else {
                        contact.show = true;
                        contactsInSearch = true;
                    }
                });

                indexLetterAsAContact.show = contactsInSearch;

                if (indexLetterAsAContact.show) {
                    directoryListAux.contacts.push(indexLetterAsAContact);
                }

                item.contacts.forEach(contact => {
                    if (contact.show) {
                        directoryListAux.contacts.push(contact);
                    }
                });
            });
        }

        return directoryListAux;
    }

    get directoryList(): Item[] {
        return this.customerContacts.map(contact => {
            return {
                id: contact.id,
                name: contact.lastName + ', ' + contact.name,
                show: true,
                adminUser: this.adminUser ? contact.adminUser : false,
            };
        });
    }

    async getContacts() {
        this.loadingContacts = true;
        this.loadingDirectoryFailed = await this.fetchDirectory(this.customerId);

        if (this.loadingDirectoryFailed) {
            this.loadingDirectoryFailed.showError();
        }
        this.loadingContacts = false;
    }

    filterByContact(contactName: string): boolean {
        if (this.contactSearch != '') {
            if (contactName.toUpperCase().includes(this.contactSearch.toUpperCase())) {
                return true;
            } else {
                return contactName
                    .toUpperCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .includes(this.contactSearch.toUpperCase());
            }
        } else {
            return true;
        }
    }

    checkSelectedID(id: number) {
        return this.selectedValues.some(value => value == id);
    }

    @user.Getter(UserGetters.GET_CURRENT_USER)
    currentUser!: User;

    @contacts.Getter(ContactsGetters.GET_DIRECTORY)
    customerContacts!: CustomerContact[];

    @contacts.Action(ContactsActions.FETCH_DIRECTORY)
    fetchDirectory!: (customerId: number) => Promise<RequestResponse>;
}
